import type { ElementType, ReactNode } from 'react'

import { useReveal } from '@/lib/motion'
import { cn } from '@/lib/cn'

/**
 * Judul yang muncul baris demi baris dari balik topeng.
 *
 * Tiap baris berada di dalam kotak yang memotong luapannya, dan isinya
 * bergeser naik dari bawah kotak itu. Yang terlihat bukan teks yang memudar,
 * melainkan teks yang seakan tercetak masuk — gerak yang jauh lebih tegas dan
 * cocok untuk judul sebesar ini.
 *
 * Pemenggalan baris ditentukan penulisnya lewat larik `lines`, bukan diukur
 * dari lebar teks. Memecah baris secara otomatis akan menghitung ulang tiap
 * kali jendela diubah ukurannya, dan itu membuat animasi tersendat pada
 * peranti lambat.
 */
export function MaskedHeading({
  lines,
  as: Tag = 'h2',
  className,
  lineClassName,
  delay = 0,
  step = 110,
}: {
  lines: ReactNode[]
  as?: ElementType
  className?: string
  lineClassName?: string
  delay?: number
  step?: number
}) {
  const ref = useReveal<HTMLElement>(delay)

  return (
    <Tag ref={ref} className={cn('reveal-lines', className)}>
      {lines.map((line, index) => (
        // Kotak pemotong memakai padding bawah kecil supaya huruf berekor
        // seperti g dan j tidak ikut terpotong saat berhenti.
        <span key={index} className={cn('block overflow-hidden pb-[0.12em]', lineClassName)}>
          <span className="masked-line block" style={{ transitionDelay: `${index * step}ms` }}>
            {line}
          </span>
        </span>
      ))}
    </Tag>
  )
}
